import { isObject } from 'lodash-es';

function getKeysNormalizer(normalizer: (key: string) => string) {
  function keysNormalizer<T>(value: T) {
    if (Array.isArray(value)) {
      return value.map(keysNormalizer);
    }

    if (isObject(value)) {
      return Object.entries(value).reduce(
        (acc, [currKey, currValue]) => ({
          ...acc,
          [normalizer(currKey)]: keysNormalizer<typeof currValue>(currValue)
        }),
        {}
      );
    }

    return value;
  }

  return keysNormalizer;
}

export default getKeysNormalizer;
